import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { clearAuthSession, getAuthToken } from "./utils/authSession";

const httpLink = createHttpLink({
  uri: "https://api.learnhut.de/query",
});

const authLink = setContext((_, { headers }) => {
  const token = getAuthToken();
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const isAuthGraphQLError = (err) => {
  const code = String(err?.extensions?.code || "").toUpperCase();
  if (code === "UNAUTHENTICATED") return true;

  const msg = String(err?.message || "").toLowerCase();
  return (
    msg.includes("unauthenticated") ||
    (msg.includes("token") && msg.includes("expired")) ||
    (msg.includes("jwt") && msg.includes("expired"))
  );
};

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const hasUnauthorizedGraphQLError =
    graphQLErrors?.some((err) => isAuthGraphQLError(err)) || false;
  const hasUnauthorizedNetworkError =
    Boolean(networkError?.statusCode === 401) ||
    Boolean(networkError?.response?.status === 401);

  if (hasUnauthorizedGraphQLError || hasUnauthorizedNetworkError) {
    clearAuthSession();
  }
});

const client = new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
